/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export const defaultTokenTypePrincipal = 'access_token';
export const defaultTokenTypeAuthentication = 'access_token';
export const defaultTokenGrantType = 'authorization_code';
export const defaultRefreshGrantType = 'refresh_token';
export const defaultCodeChallengeMethod = 'S256';
export const defaultSearchParamsToRemoveAfterAutoRedirect = ['sso_redirect'];
export const defaultSearchParamsToRemoveAfterAuthRedirect = [
    'idp_id',
    'auth_flow_step',
    'state',
    'session_state',
    'code'
];
export const mandatoryKeysForSSOProviders = [
    'id',
    'name',
    'auth_flow',
    'params',
    'auth_endpoint'
];
export const mandatoryKeysForSSOProviderParams = [
    'client_id',
    'response_type',
    'scope'
];
export const isAuthDebuggingEnabled = window.localStorage.getItem('OIDC/OAuth#EnableAuthDebugging') === 'true';
